import { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import { getMaximeter, recalculateMaximeter } from "../redux/apiCalls/data/maximetroCall";
import { Toast } from "../helpers/alert";

export default function useMaximetroData({
  branchId,
  startDate,
  endDate,
  frec,
  dispatch,
  token,
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [viewingVersion, setViewingVersion] = useState(null);

  const loadCurrent = useCallback(async () => {
    if (!branchId || !startDate || !endDate) return;

    setLoading(true);
    try {
      const res = await getMaximeter(
        dispatch,
        token,
        startDate,
        endDate,
        frec,
        branchId
      );

      setData(res);

      if (res?.meta?.is_current) {
        setViewingVersion(null);
      } else {
        setViewingVersion(res?.meta?.version_number ?? null);
      }

    } catch (err) {
      console.error("Error loading maximeter:", err);
    } finally {
      setLoading(false);
    }
  }, [branchId, startDate, endDate, frec, dispatch, token]);

  const recalculate = useCallback(async () => {
    if (!branchId) return;

    const confirm = await Swal.fire({
      title: "¿Recalcular Maxímetro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, recalcular",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    try {
      Swal.fire({
        title: "Recalculando...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const res = await recalculateMaximeter(
        token,
        startDate,
        endDate,
        branchId
      );

      setData(res);
      setViewingVersion(null);

      Swal.close();

      Toast.fire({
        icon: "success",
        title: `Nueva versión v${res?.meta?.version_number}`,
      });

    } catch (err) {
      Swal.close();
      Toast.fire({ icon: "error", title: "No se pudo recalcular." });
    }
  }, [branchId, startDate, endDate, token]);

  useEffect(() => {
    loadCurrent();
  }, [loadCurrent]);

  return {
    data,
    loading,
    viewingVersion,
    setViewingVersion,
    loadCurrent,
    recalculate,
  };
}